interface UserParameters {
  userId: number;
  userName: string;
  userLastName: string;
  userEmail: string;
  userPhoneNumber: string;
  hasPhoto: boolean;
}
export class User {
  public userId;
  public userName;
  public userLastName;
  public userEmail;
  public userPhoneNumber;
  public hasPhoto;
  constructor({userId, userName, userLastName, userEmail, userPhoneNumber, hasPhoto}: UserParameters) {
    this.userId = userId;
    this.userName = userName;
    this.userLastName = userLastName;
    this.userEmail = userEmail;
    this.userPhoneNumber = userPhoneNumber;
    this.hasPhoto = hasPhoto;
  }
}
